import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import {
  CGU, CHARTE_ETHIQUE, FAQ,
} from '../../routes';

type Props = {
  footerRef?: React.RefObject<HTMLElement>,
};

type State = {
};

class Footer extends React.Component<Props, State> {
  state: State = {
  };

  render(): ReactNode {
    return (
      <footer ref={this.props.footerRef} className="mon-compte-footer">
        <Link target="_blank" to={FAQ} className="footer-bold"><Translate value="FOOTER.HELP" /></Link>
        <Translate value="FOOTER.TITRE" />
        <Link target="_blank" to={CGU}><Translate value="FOOTER.CGU" /></Link>
        <Link target="_blank" to={CHARTE_ETHIQUE}><Translate value="FOOTER.CHARTE" /></Link>
      </footer>
    );
  }
}

export default Footer;
